
export const firebaseTimeStampToJsDate = (firestoreTimestamp: any): Date => {
    return new Date(firestoreTimestamp?.toDate());
}
